// ============================================
// MOT DE PASSE OBLIGATOIRE — état partagé
// ============================================
// Le serveur exige un nouveau mot de passe :
// - à la connexion (`mustChangePassword: true`) ;
// - ou sur n'importe quelle requête, par un 403 { code: 'MOT_DE_PASSE_A_CHANGER' }.
// Dans les deux cas, l'écran plein « Choisissez votre mot de passe »
// s'affiche. Une fois le mot de passe changé, les écrans abonnés reprennent
// (rechargement des données, reconnexion du socket).

export const CODE_MOT_DE_PASSE_A_CHANGER = 'MOT_DE_PASSE_A_CHANGER';
export const LONGUEUR_MIN_MOT_DE_PASSE = 8;

type Abonne = (exige: boolean) => void;

let exige = false;
const abonnes = new Set<Abonne>();
const reprises = new Set<() => void>();

export function changementMotDePasseExige(): boolean {
  return exige;
}

export function exigerChangementMotDePasse(): void {
  if (exige) return;
  exige = true;
  abonnes.forEach(a => a(true));
}

/** À appeler quand le nouveau mot de passe est enregistré : l'écran se ferme et le travail reprend. */
export function signalerMotDePasseChange(): void {
  exige = false;
  abonnes.forEach(a => a(false));
  reprises.forEach(r => {
    try { r(); } catch (e) { console.error('Reprise après changement de mot de passe :', e); }
  });
}

/** Oublie l'exigence sans reprise (déconnexion). */
export function oublierChangementMotDePasse(): void {
  if (!exige) return;
  exige = false;
  abonnes.forEach(a => a(false));
}

export function abonnerChangementMotDePasse(abonne: Abonne): () => void {
  abonnes.add(abonne);
  return () => { abonnes.delete(abonne); };
}

/** Action à rejouer après le changement (recharger, reconnecter). */
export function surRepriseApresMotDePasse(reprise: () => void): () => void {
  reprises.add(reprise);
  return () => { reprises.delete(reprise); };
}

/** Une réponse HTTP signifie-t-elle « mot de passe à changer » ? */
export function estReponseMotDePasseAChanger(status: number, corps: unknown): boolean {
  return status === 403
    && !!corps && typeof corps === 'object'
    && (corps as Record<string, unknown>).code === CODE_MOT_DE_PASSE_A_CHANGER;
}

/** Contrôle de saisie de l'écran ; null si tout est bon, sinon le message à afficher. */
export function verifierNouveauMotDePasse(nouveau: string, confirmation: string, actuel?: string): string | null {
  if (actuel !== undefined && !actuel) return 'Saisissez votre mot de passe actuel.';
  if (nouveau.length < LONGUEUR_MIN_MOT_DE_PASSE) return `Le nouveau mot de passe doit faire au moins ${LONGUEUR_MIN_MOT_DE_PASSE} caractères.`;
  if (nouveau !== confirmation) return 'La confirmation ne correspond pas au nouveau mot de passe.';
  if (actuel !== undefined && nouveau === actuel) return "Le nouveau mot de passe doit être différent de l'actuel.";
  return null;
}
